// hooks/useChatBundle.js
import { useState, useEffect, useCallback, useRef } from 'react';

/**
 * Determine whether we should avoid connecting to the IN (Indian) backend.
 * Returns true if the current hostname is one of the internal hosts.
 * (Change this condition if you need different behaviour.)
 */
const shouldAvoidInServer = (() => {
  const hostname = window.location.hostname;
  // Avoid IN server on these specific hosts
  const isInternalHost = hostname === "122.160.157.99" || hostname === "dev.tezkit.com";
  return isInternalHost;   // <-- now true on those IPs → no IN connection
})();

console.log(`🚫 ChatBundle – Avoid IN server connections: ${shouldAvoidInServer}`);

export const useChatBundle = (initialShouldLoad = true) => {
  console.log("can you see these logs?")
  const [shouldLoad, setShouldLoad] = useState(initialShouldLoad);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);

  // Use ref to track mounted state for cleanup
  const isMounted = useRef(true);

  const enableBundle = useCallback(() => {
    setShouldLoad(true);
  }, []);

  const disableBundle = useCallback(() => {
    setShouldLoad(false);
  }, []);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!shouldLoad) return;

    const alreadyLoaded = document.querySelector('script[data-loaded="qchat-bundle"]');
    console.log("this port is not correct", process.env.REACT_APP_PRIMARY_SERVER_PORT)
    const loadAndInitialize = async () => {
      try {
        // If already loaded, just ensure MyPackage is initialized
        if (alreadyLoaded) {
          if (window.MyPackage && !window.MyPackage._initialized) {
            setLoading(true);
            const us_backend_api = `${process.env.REACT_APP_PRIMARY_SERVER_DOMAIN}:${process.env.REACT_APP_PRIMARY_SERVER_PORT}`;
            const in_south1_be_api = `${process.env.REACT_APP_SECONDARY_SERVER_DOMAIN}:${process.env.REACT_APP_SECONDARY_SERVER_PORT}`;

            const regions = [
              { ip: us_backend_api, region: 'US' }
            ];

            // Only add IN region if we are NOT avoiding it
            if (!shouldAvoidInServer) {
              regions.push({
                ip: in_south1_be_api,
                region: 'IN'
              });
            }

            await window.MyPackage.init(undefined, regions);
            window.MyPackage._initialized = true;
          }
          if (isMounted.current) {
            setLoading(false);
            setLoaded(true);
          }
          return;
        }

        const script = document.createElement("script");
        script.defer = true;
        script.dataset.loaded = "qchat-bundle";

        const dev_mode = process.env.REACT_APP_DEV_MODE;
        console.log("HERE IS CURRENT dev_mode",dev_mode)
        script.src = "https://magicchat-core.github.io/prod-ac-cdns/bundle.umd.js";

        if (isMounted.current) {
          setLoading(true);
          setError(null);
        }

        // Create a promise to handle script loading
        const scriptLoadPromise = new Promise((resolve, reject) => {
          script.onload = () => resolve();
          script.onerror = () => reject(new Error("Failed to load chat bundle script"));
        });

        document.body.appendChild(script);

        // Wait for script to load
        await scriptLoadPromise;

        // Now initialize the package
        if (window.MyPackage && !window.MyPackage._initialized) {
          const us_backend_api = `${process.env.REACT_APP_PRIMARY_SERVER_DOMAIN}:${process.env.REACT_APP_PRIMARY_SERVER_PORT}`;
          const in_south1_be_api = `${process.env.REACT_APP_SECONDARY_SERVER_DOMAIN}:${process.env.REACT_APP_SECONDARY_SERVER_PORT}`;

          console.log(
            in_south1_be_api,
            "in_south1_be_api - us_backend_api",
            us_backend_api
          );

          const regions = [
            { ip: us_backend_api, region: "US" }
          ];

          // Only add IN region if we are NOT avoiding it
          if (!shouldAvoidInServer) {
            regions.push({
              ip: in_south1_be_api,
              region: "IN"
            });
          }

          await window.MyPackage.init(undefined, regions);
          window.MyPackage._initialized = true;
        }

        if (isMounted.current) {
          setLoading(false);
          setLoaded(true);
        }
      } catch (err) {
        console.error('Failed to load or initialize chat bundle:', err);
        if (isMounted.current) {
          setError(err.message || "Failed to load chat bundle");
          setLoading(false);
        }
      }
    };

    loadAndInitialize();

    // Cleanup function - only resets loading state if not loaded yet
    return () => {
      if (!loaded && isMounted.current) {
        setLoading(false);
      }
    };
  }, [shouldLoad, loaded]);

  return {
    loading,
    error,
    loaded,
    enableBundle,
    disableBundle,
    shouldLoad
  };
};